import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/messaging/headerRightBg.png';
import headerRightBg375 from '../images/messaging/headerRightBg375.png';
import PersonMessageBubbles from '../images/messaging/PersonMessageBubbles.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import ImacBellPhone from '../images/messaging/ImacBellPhone.svg';
import CloudServer from '../images/messaging/CloudServer.svg';
import ProfileGear from '../images/messaging/ProfileGear.svg';
import halfSectionGradient from '../images/dashboard/halfSectionGradient.png';
import fullWidthSplitBg from '../images/dashboard/fullWidthSplitBg.png';
import TwoFAImacSmartphone from '../images/messaging/TwoFAImacSmartphone.svg';
import WantToSeeHow from '../components/WantToSeeHow';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const MessagingHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `55px`, paddingBottom: `45px`}}>
		<h1>Messaging</h1>
		<p>Real-time communication<br />during the loan process</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 85%;
		margin-bottom: 3em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 484px;
			margin-bottom: 3em;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
			margin-bottom: 5em;
		}
	}
`;

const PersonMessageBubblesFigure =
	<HeaderBottomContentFigure>
		<PersonMessageBubbles alt='Person messaging on laptop' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	&.full-width-split {

		@media (${(props) => props.theme.mediumUp}) {
			& .responsivePadding#alignStretch {
				align-items: stretch;

				& article {
					align-items: center;
					display: flex;
				}
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.whiteLeftLtGreenRight {
			background-image: ${(props) => `url('${fullWidthSplitBg}')`};
		}
	}
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const problemExtraStyle = { paddingRight: `4em` };

const MessagingPage = (props: any) => {
	return (
	<Layout
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgPosition={'right top'}
		headerSplashBg={headerRightBg}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPositionLarge={'center 0'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={PersonMessageBubblesFigure}
		headerContentClass={'product'}
		headerContent={MessagingHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='Messaging - Communication with customers'
		metaDescription={'Automate customer and third-party dealer engagement with a cloud-based messaging system so borrowers are always in the know.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'495px'}
		BodyClass={'Messaging'}
	>
		<ProblemSolution
			problem={'Customers are disconnected and out of the loop if they do not receive status updates at each step of the loan process.'}
			solution={"Messaging's system-generated notifications keep customers up-to-date during the borrowing experience, saving underwriters from drafting custom emails."}
			problemExtraStyle={problemExtraStyle}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#73d6c4'}

			leftIcon = {<ImacBellPhone alt='Desktop PC and Smartphone notifications' style={{margin: `1px 0`}} />}
			leftHeading = {'Email and SMS\nnotifications'}
			leftText={'Automate alerts to share status updates with your customers and third-party dealers.'}

			middleIcon = {<CloudServer alt='cloud server' style={{margin: `0`}} />}
			middleHeading = {'Cloud\ncommunications'}
			middleText = {'Scale your lending operations with continuous customer engagement.'}

			rightIcon = {<ProfileGear alt='customer profile settings' style={{margin: `0`}} />}
			rightHeading = {'Message\ntemplates'}
			rightText = {'Pre-fill customer data to deliver intuitive, personalized journeys.'}
		/>
		<Section className='usher-customers row row-flush centered' id='MessagingSplit'>
			<article className='col-12 col-md-6 right-on-desktop'>
				<div className='product text-box'>
					<header>
						<h2>Usher your customers<br />from application to close</h2>
					</header>
					<p>The lending industry is moving fast, and one missed communication with a customer could jeopardize the relationship. Leverage business process automation to usher your customers or indirect dealers seamlessly through complex loan processes.</p><p>With automated status updates, it's never been this easy to customize your messaging and serve your community every step of the way.</p>
				</div>
			</article>
			<figure className='col-12 col-md-6'>
				<TwoFAImacSmartphone alt='2-factor authenticaion' />
			</figure>
		</Section>
		<div className='centeredWrapper'>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default MessagingPage;
